import React, { Component } from "react";
import TabSelector from "../../components/CircleAdminTabs";
import CircleChat from "../CircleChat";
import Booking from "../Booking";
import Expenses from "../Expenses";
import Agreement from "../Agreement";
import UsageLogs from "../UsageLogs";

import { navigate } from "../../store/navigation/operations";
import { connect } from "react-redux";
import { fetchCircle } from "../../store/my_circles/operations";
import { fetchCommitment, signAgreement } from "../../store/commitment/operations";
import { fetchMemberRequests, updateMemberRequest } from "../../store/member_requests/operations";
import { getMemberRequests, updatingRequests } from "../../store/member_requests/selectors";
import { userHasCommitment, isAgreementLoading } from "../../store/commitment/selectors";
import {
  getCircleWithId,
  loadingInitialCirclesList,
  hasAgreement,
  isPrylpoolenCircle,
} from "../../store/my_circles/selectors";
import { loggedInUserGuid } from "../../store/iam/selectors";

const admin_tabs = {
  chat: { name: "chat", icon: "chat", key: "chat" },
  booking: { name: "booking", icon: "calendar", key: "booking" },
  expenses: { name: "expenses", icon: "bank-account", key: "expenses" },
  agreement: { name: "agreement", icon: "endorsed", key: "agreement" },
  log: { name: "log", icon: "clipboard", key: "log" },
};

// const status_and_tabs_map = {
//   member_gathering: ["chat", "agreement", "x_expenses", "x_booking"],
//   awaiting_commitment: ["agreement", "chat", "x_expenses", "x_booking"],
//   awaiting_purchase: ["chat", "agreement", "x_expenses", "x_booking"],
//   completed: ["expenses", "booking", "chat", "agreement"],
//   pending: ["chat", "x_agreement", "x_expenses", "x_booking"]
// };

const status_and_tabs_map = {
  member_gathering: ["chat", "agreement", "expenses", "booking", "log"],
  awaiting_commitment: ["agreement", "chat", "expenses", "booking", "log"],
  awaiting_purchase: ["chat", "agreement", "expenses", "booking", "log"],
  completed: ["expenses", "booking", "chat", "agreement", "log"],
  pending: ["chat", "agreement", "expenses", "booking", "log"],
  hidden:["agreement", "chat", "expenses", "booking", "log"]
};

const prylpoolen_tabs_to_hide = ["log", "expenses", "agreement", "chat"];

class CircleTabs extends Component {
  state = {
    selected_tab: "",
    tabs: [],
  };

  populateTabs = () => {
    let tabs = [];
    status_and_tabs_map[this.props.circle.status].forEach((tab) => {
      if (this.props.is_prylpoolen && prylpoolen_tabs_to_hide.includes(tab)) {
        return;
      }

      if (tab === "agreement" && !this.props.has_agreement) {
        //verify if necessary
        return;
      }

      if (tab.indexOf("x_") === 0) {
        let tab_to_push = { ...admin_tabs[tab.replace("x_", "")] };
        tab_to_push.disabled = true;
        tabs.push(tab_to_push);
      } else {
        tabs.push(admin_tabs[tab]);
      }
    });
    let new_state = { tabs: tabs };
    if (this.state.selected_tab === "") {
      new_state.selected_tab = tabs[0].key;
    }
    this.setState(new_state);
  };

  selectTab = (key) => {
    this.setState({ selected_tab: key });
  };

  componentDidMount() {
    this.populateTabs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.circle.status !== prevProps.circle.status) {
      this.populateTabs();
    }
  }

  render() {
    return (
      <>
        {this.props.circle && (
          <>
            <TabSelector collections={this.state.tabs} onTabClick={this.selectTab} selected={this.state.selected_tab} />
            {this.state.selected_tab === "chat" && (
              <div className="custom-card">
                <CircleChat circleId={this.props.circleId} />
              </div>
            )}
            {this.state.selected_tab === "booking" && (
              <div className="custom-card">
                <Booking circleId={this.props.circleId} productId={this.props.circle.products[0].guid} />
              </div>
            )}
            {this.state.selected_tab === "agreement" && (
              <div className="custom-card">
                <Agreement circleId={this.props.circleId} />
              </div>
            )}
            {this.state.selected_tab === "expenses" && (
              <div className="custom-card">
                <Expenses circleId={this.props.circleId} productId={this.props.circle.products[0].guid} />
              </div>
            )}
            {this.state.selected_tab === "log" && (
              <div className="custom-card">
                <UsageLogs circleId={this.props.circleId} productId={this.props.circle.products[0].guid} />
              </div>
            )}
          </>
        )}
      </>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    // myGuid: loggedInUserGuid(state),
    loadingCircle: loadingInitialCirclesList(state),
    circle: getCircleWithId(state, props.circleId),
    is_prylpoolen: isPrylpoolenCircle(state, props.circleId),
    has_agreement: hasAgreement(state, props.circleId),
    request_updates: updatingRequests(state),
    member_requests: getMemberRequests(state, props.circleId),
    has_commitment: userHasCommitment(state, props.circleId, loggedInUserGuid(state)),
    agreement_loading: isAgreementLoading(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchCircle: (id, is_updating) => dispatch(fetchCircle(id, is_updating)),
  fetchCommitment: (circleId) => dispatch(fetchCommitment(circleId)),
  signAgreement: (circleId) => dispatch(signAgreement(circleId)),
  navigate: (to) => dispatch(navigate(to)),
  fetchMemberRequests: (id) => dispatch(fetchMemberRequests(id, "pending")),
  updateMemberRequest: (accept, circleId, requestId) => dispatch(updateMemberRequest(accept, circleId, requestId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CircleTabs);
